/**
 * Shared component for rendering a property flag row
 */

import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { FeatureFlagAttributes } from '@/types/admin/featureFlags';
import { ADMIN_COLORS } from '@/constants/admin';
import { getOverrideCount, formatOverrideText } from '../utils/featureFlagsUtils';

interface PropertyFlagRowProps {
  flag: FeatureFlagAttributes;
  onPress: () => void;
}

export const PropertyFlagRow: React.FC<PropertyFlagRowProps> = ({ flag, onPress }) => {
  const overrideCount = getOverrideCount(flag);
  const hasOverrides = overrideCount > 0;

  return (
    <TouchableOpacity
      key={`${flag.organization_id}-${flag.property_id || flag.id}`}
      style={styles.propertyRow}
      onPress={onPress}
      activeOpacity={0.7}
    >
      <View style={styles.propertyContent}>
        <View style={styles.propertyLeft}>
          <Text style={styles.propertyName} numberOfLines={1}>
            {flag.propertyName}
          </Text>
        </View>

        <View style={styles.propertyRight}>
          {hasOverrides && (
            <View style={styles.overrideBadge}>
              <Text style={styles.overrideText}>{formatOverrideText(overrideCount)}</Text>
            </View>
          )}
        </View>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  propertyRow: {
    backgroundColor: ADMIN_COLORS.DATA_TABLE.BACKGROUND,
    borderBottomWidth: 1,
    borderBottomColor: ADMIN_COLORS.BORDER,
  },
  propertyContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 16,
  },
  propertyLeft: {
    flex: 1,
  },
  propertyName: {
    fontSize: 14,
    fontWeight: '600',
    color: ADMIN_COLORS.TEXT.PRIMARY,
  },
  propertyRight: {
    alignItems: 'flex-end',
  },
  overrideBadge: {
    paddingHorizontal: 12,
    paddingVertical: 4,
    borderRadius: 12,
    backgroundColor: ADMIN_COLORS.PRIMARY + '33',
  },
  overrideText: {
    fontSize: 12,
    fontWeight: '500',
    color: ADMIN_COLORS.TEXT.PRIMARY,
  },
});

